<template>
  <transition name="simple-fade-create-button" @enter="handleEnter">
    <section class="pa-create-button" ref="buttonField" v-if="isOpen">
      <div class="pa-layout pa-plus-button">
        <component :is="imageComponentName" :class="buttonClass" @click.prevent="handleClick" />
      </div>
    </section>
  </transition>
</template>

<script>
import PodMessageCreateButton from '@/components/Parts/PACreateButton/Images/PodMessageCreateButton.svg?inlineN';
import BoardCreateButton      from '@/components/Parts/PACreateButton/Images/BoardCreateButton.svg?inlineN'

export default {
  data(){
    return {
      imageComponentName  : 'PodMessageCreateButton',
      buttonClass         : [],

      contentTypeSet      : {
        connection  : {
          imageName : 'PodMessageCreateButton',
          classSet  : ['pod-message-create-button']
        },

        park        : {
          imageName : 'BoardCreateButton',
          classSet  : ['board-create-button']
        }
      }
    };
  },

  components : {
    PodMessageCreateButton,
    BoardCreateButton
  },

  computed : {
    isOpen(){
      return this.$store.state.createButton.isOpen;
    },

    contentType(){
      return this.$store.state.createButton.contentType;
    },

    podRoomType(){
      return this.$store.state.connection.podRoomType;
    },

    podRoomId(){
      // return this.$store.state.connection.podRoomId;
      return this.$store.state.connection.podRoomId[this.podRoomType];
    }
  },

  watch : {
    contentType : {
      handler(value){
        if(typeof this.contentTypeSet[value] === 'undefined') return;

        this.imageComponentName = this.contentTypeSet[value].imageName;
        this.buttonClass        = this.contentTypeSet[value].classSet;
      },
      immediate: true
    }
  },

  methods : {
    handleEnter(){
      this.calcPosition();
    },

    calcPosition(){
      if((typeof this.$refs.buttonField !== 'undefined') && (document.querySelector('section.pa-icon-bar') !== null)){
        this.$refs.buttonField.style.bottom = document.querySelector('section.pa-icon-bar').offsetHeight + 'px';
      }
    },

    handleClick(){
      const sendData = {
        type        : 'createButton/updateOpenEditor',
        editorType  : this.contentType,
        value       : true,
      };

      switch(this.contentType){
        case 'connection':
          sendData['connection'] = {
            podRoomId         : this.podRoomId,
            replyPodMessageId : null,
          };
        break;
      }

      this.$store.dispatch(sendData);
    }
  },

  mounted(){
    window.addEventListener('resize', this.calcPosition);

    // setTimeout(() => {
    //   this.$store.dispatch({
    //     type        : 'createButton/updateCreateButton',
    //     isOpen      : true,
    //     contentType : 'connection',
    //   });
    // }, 5000);
  },

  beforeDestroy(){
    window.removeEventListener('resize', this.calcPosition);
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.simple-fade-create-button{
  &-enter-active{
    transition: opacity .3s;
  }

  &-leave-active{
    transition: opacity .2s;
  }
  
  &-enter, &-leave-to{
    opacity: 0;
  }
}

.pa-create-button{
  position: fixed;
  right:.5rem;
  bottom:0;
  margin-bottom:.3rem;
  user-select: none;
  width:4rem;
  height:4rem;
  z-index: 59;

  svg{
    width:4rem;
    cursor: pointer;

    &.pod-message-create-button{
      .a{fill:#fff;}
      .b{mask:url(#a);}
      .c{fill:#c49065;}
      .d{fill-opacity:0;stroke:#a4734b;stroke-width:6px;}
      .e{mask:url(#b);}
      .f{fill:#b7855c;}
      .f,.g{fill-rule:evenodd;}
      .g{fill:#5e3717;}
    }

    &.board-create-button{
      .a{fill:#fff;}
      .b{mask:url(#a);}
      .c{fill:#c49065;}
      .d,.g{fill-opacity:0;}
      .d{stroke:#a4734b;stroke-width:6px;}
      .e{mask:url(#b);}
      .f{fill:#b7855c;}
      .f,.g{fill-rule:evenodd;}
      .g{stroke:#5e3717;stroke-width:2px;}
      .h{fill:#5e3717;}
    }
  }

  @media screen and (min-width: $desktop) {
    top:22vh;
    right:inherit;
    right:calc(((100vw - 780px) / 2) - 5.5rem);
    padding-bottom: 0;
  }
}
</style>